export const providerColorCodes = (provider, visitsts) => {
  if (provider.toLowerCase().includes('madhu')) {
    provider = 'MP';
  } else if (provider.toLowerCase().includes('leanora')) {
    provider = 'BL';
  } else if (provider.toLowerCase().includes('jaime')) {
    provider = 'JN';
  } else if (provider.toLowerCase().includes('oco')) {
    provider = 'OM';
  } else if (provider.toLowerCase().includes('reshma')) {
    provider = 'RF';
  }  else if (provider.toLowerCase().includes('procedures')) {
    provider = 'MP';
  } else if (provider.toLowerCase().includes('duke')) {
    provider = 'DK';
  } else  if (provider != '' && visitsts != '') {
    provider = 'ALL';
  }

  let bgclr = '#F8EEEC';
  let clr = '#000';

  const colorMap = {
    MP: {
      'Waiting Room': { bg: '#0767be', clr: '#FFF' },
      'Ready for Triage': { bg: '#0767be', clr: '#FFF' },
      'Processing': { bg: '#0767be', clr: '#FFF' },
      'Ready for Provider': { bg: '#0767be', clr: '#FFF' },
      'With Provider': { bg: '#0767be', clr: '#FFF' },
    },
    BL: {
      'Waiting Room': { bg: '#800080', clr: '#FFF' },
      'Ready for Triage': { bg: '#800080', clr: '#FFF' },
      'Processing': { bg: '#800080', clr: '#FFF' },
      'Ready for Provider': { bg: '#800080', clr: '#FFF' },
      'With Provider': { bg: '#800080', clr: '#FFF' },
    },
    JN: {
      'Waiting Room': { bg: '#e995e7', clr: '#000' },
      'Ready for Triage': { bg: '#e995e7', clr: '#000' },
      'Processing': { bg: '#e995e7', clr: '#000' },
      'Ready for Provider': { bg: '#e995e7', clr: '#000' },
      'With Provider': { bg: '#e995e7', clr: '#000' },
    },
    OM: {
      'Waiting Room': { bg: '#008080', clr: '#FFF' },
      'Ready for Triage': { bg: '#008080', clr: '#FFF' },
      'Processing': { bg: '#008080', clr: '#FFF' },
      'Ready for Provider': { bg: '#008080', clr: '#FFF' },
      'With Provider': { bg: '#008080', clr: '#FFF' },
    },
    RF: {
      'Waiting Room': { bg: '#FF7F50', clr: '#000' },
      'Ready for Triage': { bg: '#FF7F50', clr: '#000' },
      'Processing': { bg: '#FF7F50', clr: '#000' },
      'Ready for Provider': { bg: '#FF7F50', clr: '#000' },
      'With Provider': { bg: '#FF7F50', clr: '#000' },
    },
    DK: {
      'Waiting Room': { bg: '#767828', clr: '#FFF' },
      'Ready for Triage': { bg: '#767828', clr: '#FFF' },
      'Processing': { bg: '#767828', clr: '#FFF' },
      'Ready for Provider': { bg: '#767828', clr: '#FFF' },
      'With Provider': { bg: '#767828', clr: '#FFF' },
    },
    ALL: {
      'Waiting Room': { bg: '#C8A2C8', clr: '#000' },
      'Ready for Triage': { bg: '#C8A2C8', clr: '#000' },
      'Processing': { bg: '#C8A2C8', clr: '#000' },
      'Ready for Provider': { bg: '#C8A2C8', clr: '#000' },
      'With Provider': { bg: '#C8A2C8', clr: '#000' },
    },
  };

  const defaultVisitState = 'Waiting Room';

  const providerMap = colorMap[provider];
  const visitStatus = providerMap && providerMap[visitsts] ? visitsts : defaultVisitState;

  if (providerMap && providerMap[visitStatus]) {
    const mapping = providerMap[visitStatus];
    bgclr = mapping.bg || bgclr;
    clr = mapping.clr || clr;
  }

  return [bgclr, clr];
};